import { EMPLOYEE } from 'garaje/utils/roles';
import propertiesWithLocations from './properties-with-locations';

/**
 * @param {object} server Mirage Server
 */
export default function (server) {
  const items = propertiesWithLocations(server);
  const [property1, property2] = items.propertiesWithInternalTenants;
  const [user] = server.schema.users.all().models;

  const currentUserZoneRoles = [];

  // assign user as security admin to some properties
  currentUserZoneRoles.push(server.create('zone-role', 'asZoneSecurityAdmin', { user, zone: property1 }));
  currentUserZoneRoles.push(server.create('zone-role', 'asZoneSecurityAdmin', { user, zone: property2 }));

  // make global admin a normal employee
  user.companyRoles.models.forEach((companyRole) => companyRole.update({ roleName: EMPLOYEE }));

  return { ...items, currentUserZoneRoles };
}
